import { ChainId } from '@im33357/uniswap-v2-sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '',
  [ChainId.POLY]: '',
  [ChainId.ROPSTEN]: '',
  [ChainId.KOVAN]: '',
  [ChainId.RINKEBY]: '',
  [ChainId.GÖRLI]: '',
  [ChainId.LARISSA]: '0xFCbFB448214566601E1cBF437b892F7a057EfF7C'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
